// components/PrivateRoute.js
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { isTokenExpired } from "../utilis/auth";

const PrivateRoute = ({ children }) => {
  const { token, user } = useSelector((state) => state.user);

  if (!token || isTokenExpired(token)) {
    return <Navigate to="/auth" replace />;
  }

  return children;
};

export default PrivateRoute;
